<style lang="scss" scoped>
  .container {
    .iframe-block {
      width: 100%;
      height: 100%;
      border: none;
      margin-top: 0;
    }

    .email-data-block {
      background-color: #FFF;
    }

    .header-preview {
      padding: 30px 30px 0px 30px;

      span {
        display: block;
        margin: auto 0;
        padding-top: 10px;
      }
      .preview-edit-email {
        display: block;
        position: absolute;
        margin-left: 7rem;
        width: 112px;
      }

      .edit-config:hover {
        border-bottom: 1px solid #000;
        cursor: pointer;
        width: 33px;
      }
    }

    .informations {
      padding: 20px 40px 40px 40px;

      h4 {
        border-bottom: 1px solid #eaeff3;
        padding-left: 10px;
        padding-top: 20px;
        font-size: 14px;
        padding-bottom: 5px;
      }

      span {
        padding-top: 10px;
        padding-left: 25px;
        font-weight: 700;
        font-size: 15px;
      }
    }

    .preview-title {
      h4 {
        padding-top: 0px;
      }
    }

    .email-evaluation {
      width: 100%;
      background: #FFF;
      padding: 40px;
      margin-top: 20px;

      span {
        font-size: 15px;
        padding-left: 15px;
      }

      .evaluation-item {
        padding: 10px;
      }

      .buttons-to-test {
        padding-top: 20px;
      }
    }
  }

  .breadcrumb-true {
    display: true;
  }

  .breadcrumb-false {
    display: none;
  }

  .config-space {
    padding-left: 10px;
  }
</style>

<template>
  <section>
    <div class="row">
      <div class="col-md-9">
        <h1 class="page-header">
          {{ __('Preview de email') }}
        </h1>
      </div>
      <div class="col-md-3">
        <BButtonGroup class="float-right">
          <button
            type="button"
            class="btn btn-white"
            @click="createCampaign()"
          >
            <i class="fa fa-bolt m-r-5" />{{ __('Criar campanha') }}
          </button>
          <button
            type="button"
            class="btn btn-white"
            @click="sendTest()"
          >
            <i class="fa fa-paper-plane m-r-5" />{{ __('Enviar teste') }}
          </button>
          <button
            type="button"
            class="btn btn-white"
            @click="editEmail()"
          >
            <i class="fa fa-edit m-r-5" />{{ __('Editar email') }}
          </button>
        </BButtonGroup>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="email-data-block">
            <div class="header-preview">
              <div class="row">
                <div class="col-md-4 config-space">
                  <h3>{{ __('Configurações') }}</h3>
                </div>
                <div class="col-md-1">
                  <span
                    class="edit-config"
                    @click="openConfig()"
                  >{{ __('Editar') }}</span>
                </div>
                <div class="col-md-1" />
              </div>
            </div>
            <div class="informations">
              <div class="email-data">
                <div class="preview-title">
                  <h4>{{ __('Título no Bulldesk') }}</h4>
                  <span v-html="mail.title" />
                </div>
                <div class="subject">
                  <h4>{{ __('Assunto do E-mail') }}</h4>
                  <span v-html="mail.subject" />
                </div>
                <div class="from-name">
                  <h4>{{ __('Nome do Remetente') }}</h4>
                  <span v-html="mail.from_name" />
                </div>
                <div class="from">
                  <h4>{{ __('Email do Remetente') }}</h4>
                  <span v-html="mail.from" />
                </div>
                <div class="reply_to">
                  <h4>{{ __('Respostas do e-mail para') }}</h4>
                  <span
                    v-if="mail.reply_to === ! null"
                    v-html="mail.reply_to"
                  />
                  <span v-if="mail.reply_to === null">{{ mail.from }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="email-evaluation">
            <div class="evaluation-item">
              <i class="fa fa-globe fa-3x" /><span>{{ __('Seu domínio') }} "<strong v-html="this.domain" />"<strong v-if="!this.domainVerified.dns_verified"> {{ __('não está validado') }}</strong><strong v-if="this.domainVerified.dns_verified"> está validado</strong></span>
            </div>
            <!--div class="evaluation-item">
              <i class="fa fa-image fa-3x"></i><span>Quantidade de imagens correta no conteúdo do email</span>
            </div>
            <div class="evaluation-item">
              <i class="fa fa-link fa-3x"></i><span>Excesso de links no conteúdo do email</span>
            </div>
            <div class="evaluation-item">
              <i class="fa fa-envelope-open fa-3x"></i><span>Chance do seu email ser entregue na caixa de SPAM</span>
            </div-->
          </div>
        </div>
        <div class="col-md-6">
          <iframe
            id="iframe"
            class="iframe-block"
            ref="preview"
          />
        </div>
      </div>
      <MailConfig
        :user="user"
        :mail="mail"
      />
      <MailSend
        :user="user"
        :id="mail.id"
      />
    </div>
  </section>
</template>

<script>
import { BButtonGroup } from 'bootstrap-vue';

export default {
  components: {
    BButtonGroup,
  },

  props: ['mail', 'user'],

  mounted () {
    this.$refs.preview.srcdoc = this.mail.html;
    this.getDomains();
  },

  data () {
    return {
      domain: this.mail.domain,
      domains: [],
      domainVerified: [],
    };
  },

  methods: {
    createCampaign () {
      this.$http.post(`/automation/mail/${this.mail.id}`, this.mail)
        .then((response) => {
          window.location = `/automation/${response.data.id}`;
        });
    },

    sendTest () {
      Bus.$emit('sendMailModal');
    },

    editEmail () {
      window.location = `/mail/${this.mail.id}/builder`;
    },

    openConfig () {
      Bus.$emit('modalConfigToggled');
    },

    getDomains () {
      this.$http.get('/settings/domain')
        .then((response) => {
          this.domains = response.data;

          this.domainVerified = this.domains.filter((d) => d.domain === this.domain)[0];
        });
    },
  },
};
</script>
